import userService from "../../../services/users/userService";
import i18n from "../../../i18n/index";

export default {
    data() {
        return {
            controlledMedicine: true,
            applicableMedicine: false,
            spoiledMedicine: false,
            search: "",
            headers: [{
                    text: i18n.t('headers.document-type'),
                    sortable: false,
                    value: "username"
                },
                {
                    text: i18n.t('headers.identification'),
                    sortable: false,
                    value: "username"
                },
                {
                    text: i18n.t('headers.user'),
                    sortable: false,
                    value: "username"
                },
                {
                    text: i18n.t('headers.name'),
                    sortable: false,
                    value: "name"
                },
                {
                    text: i18n.t('headers.email'),
                    sortable: false,
                    value: "email"
                },
                {
                    text: i18n.t('headers.role'),
                    sortable: false,
                    value: "name"
                },
                {
                    text: i18n.t('headers.provider'),
                    sortable: false,
                    value: "idProvider.name"
                },
                {
                    text: i18n.t('headers.branch'),
                    sortable: false,
                    value: ""
                },
                {
                    text: i18n.t('headers.user-type'),
                    sortable: false,
                    value: "status"
                },
                {
                    text: i18n.t('headers.status'),
                    sortable: false,
                    value: "status"
                }
            ],
            itemsData: []
        };
    },
    props: {},
    watch: {},
    mounted() {
        this.searchUser();
    },
    methods: {
        onRowClick(item) {
            this.$emit("row-click", item);
        },
        searchUser() {
            userService.getUser().then(response => {
                this.itemsData = response.data;
            });
        },
        searchOneUser() {
            userService.getUserOne(this.search).then(data => {
                this.itemsData = "";
                this.itemsData.push(data.data);
            });
        },
        customFilter(items, search, filter) {
            search = search.toString().toLowerCase()
            return items.filter(row => filter(row["name"], search));
        }
    }
};